import { Box, Checkbox, Chip, Grid, Tooltip, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import CustomSearch from "../../../../Components/CustomSearch/CustomSearch";
import TableContainer from "../../../../Components/TableContainer/TableContainer";
import { collection, orderBy, query, onSnapshot, where } from "firebase/firestore";
import { DATABASE } from "../../../../Config/firebase";
import useDebounce from "../../../../Components/useDebounce/useDebounce";
import ProfileImageWithFallback from "../../../../Components/ProfileImageWithFallback/ProfileImageWithFallback";
import { LocalizationProvider, DateTimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

const CustomerSelection = ({
  multipleUsersEntry,
  setMultipleUsersEntryList,
  select_user,
  setFieldValue,
  setIsNotify,
  isNotify,
  dayWisePerformance
}) => {
  const [pageSize, setPageSize] = useState(50);
  const [customerList, setCustomerList] = useState([]);
  const [allUser, setAllUser] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchCustomer, setSearchCustomer] = useState("");
  const debouncedSearch = useDebounce(searchCustomer, 500);
  const [page, setPage] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  useEffect(() => {
    // Start with empty selection - users must manually select
    if (allUser?.length > 0) {
      setFieldValue("select_user", []);
      setIsNotify([]);
    }
  }, [allUser?.[0]?.id]);
  
  const handleCommissionPercentageChange = (e, userId) => {
    const inputValue = parseFloat(e.target.value) || 0;

    setMultipleUsersEntryList((prevList) => {
      return prevList?.map((entry) => {
        const entryUserId = entry?.user_id?.doc_id || entry?.user_id?.id;
        if (entryUserId === userId) {
          const updatedCommissionPercentage = inputValue;

          const updatedTotalProfit =
            (entry?.amount_before_performance *
              entry?.gross_performance_percentage) /
            100;

          const updatedCommission =
            (updatedTotalProfit * updatedCommissionPercentage) / 100;

          const profitAfterCommission = updatedTotalProfit - updatedCommission;
          const profitToUser = updatedTotalProfit - updatedCommission;

          return {
            ...entry,
            fiddux_commission_percentage: updatedCommissionPercentage,
            balance_after_commission:
              parseFloat(entry?.amount_before_performance) +
              parseFloat(updatedTotalProfit) -
              updatedCommission,
            fiddux_commission: updatedCommission,
            total_Monthly_Profit_Loss: updatedTotalProfit,
            gross_performance_balance:
              parseFloat(entry?.amount_before_performance) +
              parseFloat(updatedTotalProfit),
            percentage_after_commission:
              (profitAfterCommission * 100) / entry?.amount_before_performance,
            profit_to_user: profitToUser,
          };
        }
        return entry;
      });
    });
  };
  const handleSelectUser = (userId) => {
    let updatedSelection;
    if (select_user?.includes(userId)) {
      updatedSelection = select_user?.filter((id) => id !== userId);
    } else {
      updatedSelection = [...select_user, userId];
    }
    setFieldValue("select_user", updatedSelection);
  };
  const handlePerformanceChange = (e, userId) => {
    const inputValue = e.target.value;
    const newValue = inputValue === "" ? "" : parseFloat(inputValue);
    setMultipleUsersEntryList((prevList) => {
      return prevList?.map((entry) => {
        const entryUserId = entry?.user_id?.doc_id || entry?.user_id?.id;
        if (entryUserId === userId) {
          const amountBeforePerformance =
            parseFloat(entry?.amount_before_performance) || 0;
          const updatedTotalProfit = (amountBeforePerformance * newValue) / 100;
          const updatedCommision = newValue
            ? (updatedTotalProfit *
              (entry?.fiddux_commission_percentage || 0)) /
            100
            : 0;

          const profitAfterCommission = updatedTotalProfit - updatedCommision;
          const profitToUser = profitAfterCommission;
          const updatedGrossPerformanceBalance =
            amountBeforePerformance + updatedTotalProfit;

          return {
            ...entry,
            gross_performance_percentage: newValue,
            total_Monthly_Profit_Loss: updatedTotalProfit,
            gross_performance_balance: updatedGrossPerformanceBalance || 0,
            fiddux_commission: updatedCommision,
            percentage_after_commission:
              amountBeforePerformance > 0
                ? (profitAfterCommission * 100) / amountBeforePerformance
                : 0,
            profit_to_user: profitToUser,
            balance_after_commission:
              updatedGrossPerformanceBalance - updatedCommision,
          };
        }
        return entry;
      });
    });
  };
  const handleSelectAllToggle = () => {
    if (select_user?.length) {
      setFieldValue("select_user", []);
      return;
    }
    // Use doc_id if available, otherwise use id (consistent with matching logic)
    const allCustomerIds = allUser?.map((customer) => customer?.doc_id || customer?.id);
    setFieldValue("select_user", allCustomerIds);
  };
  const handleNotificationChange = (userId) => {
    setIsNotify((prevNotifyList) => {
      if (prevNotifyList?.includes(userId)) {
        return prevNotifyList?.filter((id) => id !== userId);
      } else {
        return [...prevNotifyList, userId];
      }
    });
  };
  const handleSelectAllNotificationToggle = () => {
    if (isNotify?.length === allUser?.length) {
      setIsNotify([]);
    } else {
      // Use doc_id if available, otherwise use id (consistent with matching logic)
      const allCustomerIds = allUser?.map((customer) => customer?.doc_id || customer?.id);
      setIsNotify(allCustomerIds);
    }
  };
  const columns = [
    {
      field: "rowid",
      filterable: false,
      editable: false,
      sortable: false,
      disableColumnMenu: true,
      headerName: "Report",
      width: 90,
      minWidth: 90,
      renderHeader: () => (
        <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
          <span>Report</span>
        <Checkbox
          checked={select_user?.length === allUser?.length}
          indeterminate={
            select_user?.length > 0 && select_user?.length < customerList?.length
          }
          onChange={handleSelectAllToggle}
        />
        </Box>
      ),
      renderCell: (params) => {
        // Use doc_id if available, otherwise use id (consistent with matching logic)
        const userId = params?.row?.doc_id || params?.row?.id;
        return (
          <Checkbox
            checked={select_user?.includes(userId)}
            onChange={() => handleSelectUser(userId)}
          />
        );
      },
    },
    {
      field: "notification",
      filterable: false,
      editable: false,
      sortable: false,
      disableColumnMenu: true,
      headerName: "Notify", // String for DataGrid compatibility
      renderHeader: () => (
        <Box sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          cursor: "pointer"
        }}>
          Notify
          <Checkbox
            checked={isNotify?.length === allUser?.length}
            indeterminate={
              isNotify?.length > 0 && isNotify?.length < allUser?.length
            }
            onChange={handleSelectAllNotificationToggle}
          />
        </Box>
      ),
      width: 90,
      minWidth: 90,
      renderCell: (params) => {
        // Use doc_id if available, otherwise use id (consistent with matching logic)
        const userId = params?.row?.doc_id || params?.row?.id;
        return (
          <Checkbox
            checked={isNotify?.includes(userId)}
            onChange={() => handleNotificationChange(userId)}
          />
        );
      },
    },
    {
      field: "profile_image",
      headerName: "Profile",
      width: 60,
      minWidth: 60,
      filterable: false,
      editable: false,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => (
        <ProfileImageWithFallback
          src={params?.row?.profile_image || params?.row?.profile_img}
          alt="profile"
        />
      ),
    },
    {
      field: "full_name",
      headerName: "Full Name",
      minWidth: 180,
      cellClassName: "leftAlign",
      renderCell: (params) => {
        const fullName = params?.row?.full_name || "--";
        const isFrozen = params?.row?.account_operations_frozen === true;
        return (
          <Tooltip title={isFrozen ? `${fullName} — frozen: só os dias congelados são excluídos do fechamento` : fullName}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, minWidth: 0, width: "100%" }}>
              <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", minWidth: 0 }}>
                {fullName}
              </span>
              {isFrozen ? (
                <Chip
                  label="Frozen"
                  size="small"
                  sx={{ height: 18, fontSize: 10, color: "#fff", backgroundColor: "#0288d1", "& .MuiChip-label": { px: 0.75 } }}
                />
              ) : null}
            </Box>
          </Tooltip>
        );
      },
    },
    {
      field: "opening_balance",
      headerName: "Open Balance",
      minWidth: 120,
      renderCell: (params) => {
        const rowDocId = params?.row?.doc_id || params?.row?.id;
        const userEntry = multipleUsersEntry?.find(
          (entry) => (entry?.user_id?.doc_id || entry?.user_id?.id) === rowDocId
        );
        const openingBalance = userEntry?.starting_balance ?? 0;
        const formattedBalance = new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(openingBalance);
        return formattedBalance;
      },
    },
    {
      field: "total_deposits",
      headerName: "Total Deposits",
      minWidth: 120,
      renderCell: (params) => {
        const rowDocId = params?.row?.doc_id || params?.row?.id;
        const userEntry = multipleUsersEntry?.find(
          (entry) => (entry?.user_id?.doc_id || entry?.user_id?.id) === rowDocId
        );
        const totalDeposits = userEntry?.total_deposits ?? 0;
        const formattedDeposits = new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(totalDeposits);
        return formattedDeposits;
      },
    },
    {
      field: "total_withdrawals",
      headerName: "Total Withdrawals",
      minWidth: 130,
      renderCell: (params) => {
        const rowDocId = params?.row?.doc_id || params?.row?.id;
        const userEntry = multipleUsersEntry?.find(
          (entry) => (entry?.user_id?.doc_id || entry?.user_id?.id) === rowDocId
        );
        const totalWithdrawals = userEntry?.total_withdrawals ?? 0;
        const formattedWithdrawals = new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(totalWithdrawals);
        return formattedWithdrawals;
      },
    },
    {
      field: "amount_before_performance",
      headerName: "Net Balance",
      minWidth: 120,
      renderCell: (params) => {
        const rowDocId = params?.row?.doc_id || params?.row?.id;
        const userEntry = multipleUsersEntry?.find(
          (entry) => (entry?.user_id?.doc_id || entry?.user_id?.id) === rowDocId
        );
        const balanceValue =
          userEntry?.effective_capital ??
          userEntry?.starting_balance ??
          params?.row?.net_balance ??
          0;
        const formattedBalance = new Intl.NumberFormat("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(balanceValue);
        return formattedBalance;
      },
    },
    {
      field: "gross_performance_percentage",
      headerName: "Performance(%)",
      minWidth: 120,
      renderCell: (params) => {
        const rowDocId = params?.row?.doc_id || params?.row?.id;
        const user = multipleUsersEntry?.find(
          (e) => (e?.user_id?.doc_id || e?.user_id?.id) === rowDocId
        );
        // const value = user?.gross_performance_percentage?.toString() || "";
        const value = user?.gross_performance_percentage
        ? user.gross_performance_percentage.toFixed(2)
        : "0.00";
        return (
          <input
            type="number"
            value={value}
            onChange={(e) => handlePerformanceChange(e, rowDocId)}
            style={{ width: "100%", padding: "5px" }}
          />
        );
      },
    },
    {
      field: "fiddux_commission_percentage",
      headerName: "Fiddux Commission Percentage",
      minWidth: 180,
      renderCell: (params) => {
        const rowDocId = params?.row?.doc_id || params?.row?.id;
        const user = multipleUsersEntry?.find(
          (e) => (e?.user_id?.doc_id || e?.user_id?.id) === rowDocId
        );
        const value = user?.fiddux_commission_percentage?.toString() || "";

        return user ? (
          <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
            {" "}
            <input
              type="number"
              value={value}
              onChange={(e) =>
                handleCommissionPercentageChange(e, rowDocId)
              }
              style={{ width: "100%", padding: "5px" }}
            />
            <span>%</span>
          </Box>
        ) : (
          "0%"
        );
      },
    },
    {
      field: "fiddux_commission",
      headerName: "Fiddux Commission",
      minWidth: 120,
      renderCell: (params) => {
        const rowDocId = params?.row?.doc_id || params?.row?.id;
        const user = multipleUsersEntry?.find(
          (e) => (e?.user_id?.doc_id || e?.user_id?.id) === rowDocId
        );
        if (user && user?.total_Monthly_Profit_Loss && user?.fiddux_commission_percentage) {
          const commission = (user?.total_Monthly_Profit_Loss * user?.fiddux_commission_percentage) / 100;
          const formattedCommission = new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }).format(commission);

          return <span>{formattedCommission}</span>;
        }
        return <span>$0</span>;
      },
    },
    {
      field: "gross_performance_percentage1",
      headerName: "Performance",
      minWidth: 90,
      renderCell: (params) => {
        const rowDocId = params?.row?.doc_id || params?.row?.id;
        const user = multipleUsersEntry?.find(
          (e) => (e?.user_id?.doc_id || e?.user_id?.id) == rowDocId
        );

        return user ? (
          <span>
            {`${user?.gross_performance_percentage?.toFixed(2)}%` || "0%"}
          </span>
        ) : (
          "0%"
        );
      },
    },
    {
      field: "percentage_after_commission",
      headerName: "Liquid Performance(%)",
      minWidth: 150,
      renderCell: (params) => {
        const rowDocId = params?.row?.doc_id || params?.row?.id;
        const user = multipleUsersEntry?.find(
          (e) => (e?.user_id?.doc_id || e?.user_id?.id) == rowDocId
        );

        return user ? (
          <span>
            {`${user?.percentage_after_commission?.toFixed(4)}%` || "0%"}
          </span>
        ) : (
          "0%"
        );
      },
    },
    {
      field: "final_balance",
      headerName: "Final Balance",
      minWidth: 120,
      renderCell: (params) => {
        const rowDocId = params?.row?.doc_id || params?.row?.id;
        const user = multipleUsersEntry?.find(
          (e) => (e?.user_id?.doc_id || e?.user_id?.id) == rowDocId
        );
        
        // Calculate final balance: current net_balance + profit_to_user
        // This is the actual balance the client will have after closing
        const currentNetBalance = params?.row?.net_balance || 0;
        const profitToUser = user?.profit_to_user || 0;
        const finalBalance = currentNetBalance + profitToUser;
        
        const formattedBalance = new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(finalBalance);
        
        return (
          <Tooltip title={`Current: ${new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(currentNetBalance)} + Profit: ${new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(profitToUser)}`}>
            <span>{formattedBalance}</span>
          </Tooltip>
        );
      },
    },
    {
      field: "profit_to_user",
      headerName: "Profit to Client",
      minWidth: 200,
      renderCell: (params) => {
        const rowDocId = params?.row?.doc_id || params?.row?.id;
        const user = multipleUsersEntry?.find(
          (e) => (e?.user_id?.doc_id || e?.user_id?.id) == rowDocId
        );
        const formattedCommission = new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(user?.profit_to_user);
        return formattedCommission
      },
    },
  ];

  // Fetch all users from Firestore (only once, using onSnapshot for real-time updates)
  useEffect(() => {
    setIsLoading(true);
    const customerQuery = query(
      collection(DATABASE, "users"),
      orderBy("registered_date", "desc"),
      where("status", "==", 1)
    );
    const unsubscribe = onSnapshot(
      customerQuery,
      (snapshot) => {
        const data = snapshot?.docs
          .map((doc, index) => ({
            rowid: index + 1,
            id: doc?.id,
            ...doc?.data(),
          }))?.filter((doc) => doc?.role === 1);
        setAllUser(data);
        setIsLoading(false);
      },
      (error) => {
        console.error("Error fetching customers:", error);
        setIsLoading(false);
      }
    );
    
    return () => unsubscribe();
  }, []);

  // Apply filtering when allUser or multipleUsersEntry changes
  useEffect(() => {
    if (!allUser?.length || !multipleUsersEntry?.length) {
      setCustomerList([]);
      setTotalCount(0);
      return;
    }
    
    // Filter to only show users who have been processed (have entry in multipleUsersEntry)
    // IMPORTANT: Some users have both doc_id and id, and they might be different
    // We need to collect ALL possible IDs (both doc_id and id) from multipleUsersEntry
    const processedUserIds = new Set();
    multipleUsersEntry?.forEach(entry => {
      const docId = entry?.user_id?.doc_id;
      const id = entry?.user_id?.id;
      if (docId) processedUserIds.add(docId);
      if (id) processedUserIds.add(id);
    });
    
    console.log('🔍 DEBUG: CustomerSelection - Filtering processed users:');
    console.log(`   Total users from Firestore: ${allUser?.length}`);
    console.log(`   Processed user IDs (from multipleUsersEntry): ${Array.from(processedUserIds).length} unique IDs`);
    console.log(`   multipleUsersEntry length: ${multipleUsersEntry?.length}`);
    console.log(`   Processed IDs (first 10):`, Array.from(processedUserIds).slice(0, 10));
    
    // Check if user matches any of the processed IDs (doc_id or id)
    const processedUsers = allUser?.filter(user => {
      const userDocId = user?.doc_id;
      const userId = user?.id;
      const matches = processedUserIds.has(userDocId) || processedUserIds.has(userId);
      
      // DEBUG: Log Francesco and Luca specifically
      if (user?.full_name === 'Francesco bono' || user?.email === 'bonofranz88@gmail.com') {
        console.log(`   🔍 Francesco bono: userDocId=${userDocId}, userId=${userId}, matches=${matches}`);
        console.log(`      Entry in multipleUsersEntry:`, multipleUsersEntry?.find(e => 
          e?.user_id?.doc_id === userDocId || e?.user_id?.id === userDocId ||
          e?.user_id?.doc_id === userId || e?.user_id?.id === userId
        ));
      }
      if (user?.full_name === 'Luca Governo' || user?.email === 'lucagoverno9@gmail.com') {
        console.log(`   🔍 Luca Governo: userDocId=${userDocId}, userId=${userId}, matches=${matches}`);
        console.log(`      Entry in multipleUsersEntry:`, multipleUsersEntry?.find(e => 
          e?.user_id?.doc_id === userDocId || e?.user_id?.id === userDocId ||
          e?.user_id?.doc_id === userId || e?.user_id?.id === userId
        ));
      }
      
      return matches;
    });
    
    console.log(`   ✅ Filtered processed users: ${processedUsers?.length}`);
    
    const searchFilter = debouncedSearch?.toLowerCase();
    const filteredData = processedUsers?.filter(
      ({ email = "", full_name = "", net_balance = "" }) =>
        email?.toLowerCase()?.includes(searchFilter) ||
        full_name?.toLowerCase()?.includes(searchFilter) ||
        net_balance?.toString()?.includes(searchFilter)
    );
    
    setCustomerList(
      filteredData?.slice(
        page * pageSize,
        (page + 1) * pageSize
      )
    );
    setTotalCount(filteredData?.length);
  }, [allUser, multipleUsersEntry, debouncedSearch, page, pageSize]);

  // Calculate default ledger date (start of next month after closing month)
  const defaultLedgerDate = dayWisePerformance?.select_Month
    ? dayjs(dayWisePerformance.select_Month).add(1, "month").startOf("month")
    : dayjs().add(1, "month").startOf("month");
  
  const ledgerDateValue = dayWisePerformance?.ledgerDate 
    ? dayjs(dayWisePerformance.ledgerDate) 
    : defaultLedgerDate;

  // Calculate profit/loss totals by user type
  // IMPORTANT: Only calculate for SELECTED users (select_user), not all processed users
  // This ensures consistency with rollback and email calculations
  const calculateProfitLossByType = () => {
    let individualTotal = 0;
    let corporateTotal = 0;
    let individualCount = 0;
    let corporateCount = 0;
    let unknownCount = 0;
    
    // Get list of selected user IDs
    const selectedUserIds = select_user?.map(user => 
      user?.doc_id || user?.id || user
    ) || [];
    
    if (multipleUsersEntry && allUser) {
      multipleUsersEntry.forEach(entry => {
        const entryDocId = entry?.user_id?.doc_id;
        const entryId = entry?.user_id?.id;
        const userId = entryDocId || entryId;
        
        // Only include if user is selected
        // Check both doc_id and id from select_user
        const isSelected = selectedUserIds.some(selectedId => 
          selectedId === entryDocId || selectedId === entryId || selectedId === userId
        );
        
        if (!isSelected) {
          return; // Skip unselected users
        }
        
        // Find user in allUser by matching either doc_id or id
        const user = allUser.find(u => {
          const uDocId = u?.doc_id;
          const uId = u?.id;
          return uDocId === entryDocId || uId === entryDocId || uDocId === entryId || uId === entryId;
        });
        const profitLoss = parseFloat(entry?.profit_to_user || 0);
        
        // DEBUG: Log user type classification
        if (user?.user_type === 0) {
          // Individual Customer
          individualTotal += profitLoss;
          individualCount++;
        } else if (user?.user_type === 1) {
          // Corporate Customer
          corporateTotal += profitLoss;
          corporateCount++;
        } else {
          // Unknown type - treat as individual for consistency with rollback
          individualTotal += profitLoss;
          unknownCount++;
          console.log(`⚠️ User ${userId} (${user?.full_name || user?.email || 'Unknown'}) has unknown user_type: ${user?.user_type}, treating as individual`);
        }
      });
    }
    
    // DEBUG: Log totals and missing users
    console.log('📊 Tela 3 - Profit/Loss Calculation (SELECTED users only):');
    console.log(`   Selected users count: ${selectedUserIds.length}`);
    console.log(`   Individual: ${individualCount} clients, Total: $${individualTotal.toFixed(2)}`);
    console.log(`   Corporate: ${corporateCount} clients, Total: $${corporateTotal.toFixed(2)}`);
    console.log(`   Unknown type: ${unknownCount} clients (treated as individual)`);
    console.log(`   Total clients: ${individualCount + corporateCount + unknownCount}`);
    console.log(`   Grand Total: $${(individualTotal + corporateTotal).toFixed(2)}`);
    
    // DEBUG: Check if Francesco and Luca are in multipleUsersEntry but not selected
    const francescoEntry = multipleUsersEntry?.find(e => 
      e?.user_id?.full_name === 'Francesco bono' || 
      e?.user_id?.email === 'bonofranz88@gmail.com' ||
      e?.user_id?.doc_id === 'igh16uiOxOhd2DzcDeKOmUHTbcp2' ||
      e?.user_id?.id === 'OqnqwXNd84yPuWHkPfUH'
    );
    const lucaEntry = multipleUsersEntry?.find(e => 
      e?.user_id?.full_name === 'Luca Governo' || 
      e?.user_id?.email === 'lucagoverno9@gmail.com' ||
      e?.user_id?.doc_id === 'xcsoLsBmp3NO5SgL0akEuBqQWCN2' ||
      e?.user_id?.id === 'J73cYmT7GKLWkihApbt0'
    );
    
    if (francescoEntry) {
      const francescoId = francescoEntry?.user_id?.doc_id || francescoEntry?.user_id?.id;
      const isSelected = selectedUserIds.some(id => id === francescoId || id === francescoEntry?.user_id?.doc_id || id === francescoEntry?.user_id?.id);
      console.log(`   🔍 Francesco bono: Entry exists, doc_id=${francescoEntry?.user_id?.doc_id}, id=${francescoEntry?.user_id?.id}, isSelected=${isSelected}, profit_to_user=$${francescoEntry?.profit_to_user?.toFixed(2) || '0.00'}`);
    } else {
      console.log(`   ⚠️ Francesco bono: NOT FOUND in multipleUsersEntry`);
    }
    
    if (lucaEntry) {
      const lucaId = lucaEntry?.user_id?.doc_id || lucaEntry?.user_id?.id;
      const isSelected = selectedUserIds.some(id => id === lucaId || id === lucaEntry?.user_id?.doc_id || id === lucaEntry?.user_id?.id);
      console.log(`   🔍 Luca Governo: Entry exists, doc_id=${lucaEntry?.user_id?.doc_id}, id=${lucaEntry?.user_id?.id}, isSelected=${isSelected}, profit_to_user=$${lucaEntry?.profit_to_user?.toFixed(2) || '0.00'}`);
    } else {
      console.log(`   ⚠️ Luca Governo: NOT FOUND in multipleUsersEntry`);
    }
    
    return { 
      individualTotal, 
      corporateTotal, 
      individualCount, 
      corporateCount,
      totalClientsCount: individualCount + corporateCount + unknownCount
    };
  };

  const { individualTotal, corporateTotal, individualCount, corporateCount, totalClientsCount } = calculateProfitLossByType();
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Grid container spacing={3} sx={{ mb: 3 }}>
        <Grid item xs={12} md={4}>
          <CustomSearch
            placeholder="Search Customer (Email, Full Name, Ledger)"
            value={searchCustomer}
            onChange={(event) => setSearchCustomer(event.target.value)}
            onClear={() => setSearchCustomer("")}
            style={{ border: "1px solid #000" }}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Box>
              <Typography variant="body2" sx={{ mb: 1, color: "#fff", fontWeight: 500 }}>
                Ledger Entry Date/Time
              </Typography>
              <Typography variant="caption" sx={{ mb: 1, color: "rgba(255,255,255,0.7)", display: "block" }}>
                Choose when the performance ledger entry should be dated (default: start of next month)
              </Typography>
              <DateTimePicker
                value={ledgerDateValue}
                onChange={(newValue) => {
                  setFieldValue("dayWisePerformance.ledgerDate", newValue);
                }}
                slotProps={{
                  textField: {
                    variant: "outlined",
                    fullWidth: true,
                    size: "small",
                    sx: {
                      backgroundColor: "#fff",
                      "& .MuiInputBase-root": {
                        color: "black",
                        fontSize: "14px",
                      },
                    },
                    placeholder: "Select date and time",
                  },
                }}
              />
            </Box>
          </LocalizationProvider>
        </Grid>
        <Grid item xs={12} md={4}>
          <Box sx={{ 
            p: 2, 
            backgroundColor: "rgba(42, 245, 152, 0.1)", 
            borderRadius: 2,
            border: "1px solid rgba(42, 245, 152, 0.3)"
          }}>
            <Typography variant="body2" sx={{ mb: 1, color: "#fff", fontWeight: 600 }}>
              Total Profit/Loss Summary
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
              <Box>
                <Typography variant="caption" sx={{ color: "rgba(255,255,255,0.7)", display: "block" }}>
                  Individual Customers ({individualCount}):
                </Typography>
                <Typography variant="h6" sx={{ color: individualTotal >= 0 ? "#2af598" : "#f52a2d", fontWeight: 700 }}>
                  {formatCurrency(individualTotal)}
                </Typography>
              </Box>
              <Box>
                <Typography variant="caption" sx={{ color: "rgba(255,255,255,0.7)", display: "block" }}>
                  Corporate Customers ({corporateCount}):
                </Typography>
                <Typography variant="h6" sx={{ color: corporateTotal >= 0 ? "#2af598" : "#f52a2d", fontWeight: 700 }}>
                  {formatCurrency(corporateTotal)}
                </Typography>
              </Box>
              <Box sx={{ mt: 1, pt: 1, borderTop: "1px solid rgba(255,255,255,0.2)" }}>
                <Typography variant="caption" sx={{ color: "rgba(255,255,255,0.7)", display: "block" }}>
                  Total ({totalClientsCount} clients):
                </Typography>
                <Typography variant="h6" sx={{ color: (individualTotal + corporateTotal) >= 0 ? "#2af598" : "#f52a2d", fontWeight: 700 }}>
                  {formatCurrency(individualTotal + corporateTotal)}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid>
      <Box sx={{ width: "100%", paddingTop: "24px" }}>
        <TableContainer
          rows={customerList}
          columns={columns}
          loading={isLoading}
          page={page}
          pageSize={pageSize}
          totalCount={totalCount}
          handlePageChange={(newPage) => setPage(newPage)}
          onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          paginationShow={true}
          SXHEAD={{
            background: "linear-gradient(148.97deg, #0C2C50 0%, #450F5B 100%)",
            color: "#fff",
          }}
        />
      </Box>
    </Box>
  );
};
export default CustomerSelection;
